function CancelSecondPillarExchangeApplication(config, renderer) {
  this.init = function() {
    return {
      firstName: session.user.firstName,
      lastName: session.user.lastName,
      personalCode: session.user.personalCode
    }
  }

  this.done = function (urlParams) {
    let applicationDocumentId = urlParams['documentId'];
    loadPendingApplication(applicationDocumentId);
    $('#sign-cancel-application').on('click', function() {
      cancelExchangeApplication(applicationDocumentId)
    })
  }

  function loadPendingApplication(applicationDocumentId) {
    Fetch.get('/application/second-pillar/pending-exchange-applications').then(function (applications) {
      let application = applications.find((application) => application.documentId === applicationDocumentId)

      $('#pending-application-details').html(renderer.render('pending-application-details-template', {
        application: application
      })).fadeIn()
    });
  }

  function cancelExchangeApplication(applicationDocumentId) {
    function prepareCancellationRows() {
      return $.post('/application/second-pillar/pending-exchange-applications/cancel/prepare', {
        applicationDocumentId: applicationDocumentId
      })
    }

    new ContactData().init(function () {
      new Signer(session.authType, prepareCancellationRows, onSigned).sign()
    })
  }

  function sendApplication(signedDocument) {
    return $.post('/application/second-pillar/pending-exchange-applications/cancel/send', signedDocument)
      .fail(function (xhr) {
        Logger.error('Application  : ' + xhr.responseText)
        $('#technical-error').removeClass('d-none')
      })
  }

  function onSigned(signedDocument) {
    sendApplication(signedDocument).then(function () {
      location.href = '#success?cancellation=true' +
        '&signedDocumentId=' + signedDocument['signedDocumentId'] +
        '&applicationId=' + signedDocument['applicationId']
    })
  }
}
